export default __webpack_public_path__ + "static/media/json.6ef9416a.png";